import { RefreshCw } from 'lucide-react'

interface PullToRefreshIndicatorProps {
  pullDistance: number
  pullProgress: number
  isRefreshing: boolean
  threshold?: number
}

export function PullToRefreshIndicator({
  pullDistance,
  pullProgress,
  isRefreshing,
  threshold = 80
}: PullToRefreshIndicatorProps) {
  // 表示しない場合
  if (pullDistance <= 0 && !isRefreshing) {
    return null
  }

  // モバイルはヘッダー非表示になったため、ステータスバー直下に表示
  const topOffset = 'calc(env(safe-area-inset-top, 0px) + 8px)'

  return (
    <div
      className="fixed left-0 right-0 flex items-center justify-center z-30 pointer-events-none"
      style={{
        top: topOffset,
        height: `${Math.min(pullDistance, threshold)}px`,
        transition: isRefreshing ? 'none' : 'height 0.2s ease-out'
      }}
    >
      <div
        className={`
          flex items-center justify-center
          w-10 h-10 rounded-full
          bg-white shadow-lg border border-gray-200
          ${isRefreshing ? 'animate-spin-smooth' : ''}
        `}
        style={{
          opacity: Math.min(pullProgress * 1.5, 1),
          transform: `rotate(${pullProgress * 180}deg) scale(${0.5 + pullProgress * 0.5})`,
          transition: isRefreshing ? 'none' : 'transform 0.1s ease-out, opacity 0.1s ease-out'
        }}
      >
        <RefreshCw
          className={`w-5 h-5 ${pullProgress >= 1 || isRefreshing ? 'text-indigo-600' : 'text-gray-400'}`}
        />
      </div>
    </div>
  )
}
